import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 2,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 flex flex-col items-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0a1e 0%, #1a0a1e 50%, #0a0a1e 100%)'
  }} data-id="element-362">
      {/* Ambient red glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.06] pointer-events-none" style={{
      background: 'radial-gradient(circle, #ef4444 0%, transparent 70%)'
    }} data-id="element-363" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl w-full flex flex-col items-center text-center relative z-10" data-id="element-364">
        {/* Label badge */}
        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-red-500/25 mb-8" style={{
        background: 'linear-gradient(135deg, rgba(239,68,68,0.08) 0%, rgba(239,68,68,0.02) 100%)',
        boxShadow: '0 0 20px rgba(239,68,68,0.08)'
      }} data-id="element-365">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-366" />
          <span className="text-red-400 text-xs font-bold tracking-[0.2em] uppercase" style={{
          textShadow: '0 0 8px rgba(239,68,68,0.3)'
        }} data-id="element-367">
            Precio de lanzamiento
          </span>
        </div>

        <h2 className="text-xl sm:text-2xl font-extrabold text-white mb-10 uppercase tracking-wider" style={{
        textShadow: '0 0 20px rgba(255,255,255,0.05)'
      }} data-id="element-368">
          Esta oferta cierra en:
        </h2>

        {/* Timer boxes */}
        <div className="flex items-center justify-center gap-3 sm:gap-5 mb-10" data-id="element-369">
          <div className="flex flex-col items-center" data-id="element-370">
            <div className="px-5 sm:px-7 py-4 sm:py-5 rounded-xl" style={{
            background: 'linear-gradient(180deg, rgba(239,68,68,0.1) 0%, rgba(239,68,68,0.03) 100%)',
            border: '1px solid rgba(239,68,68,0.2)',
            boxShadow: '0 0 30px rgba(239,68,68,0.08), 0 0 60px rgba(239,68,68,0.03), inset 0 1px 0 rgba(239,68,68,0.1)'
          }} data-id="element-371">
              <span className="text-5xl sm:text-7xl font-black text-red-500 leading-none tracking-tighter" style={{
              textShadow: '0 0 20px rgba(239,68,68,0.5), 0 0 40px rgba(239,68,68,0.2)'
            }} data-id="element-372">
                {formatTime(timeLeft.hours)}
              </span>
            </div>
            <span className="text-gray-500 text-[9px] sm:text-[10px] font-bold mt-2.5 tracking-[0.2em] uppercase" data-id="element-373">
              Horas
            </span>
          </div>

          <span className="text-3xl sm:text-5xl font-black text-red-500/50 -mt-6" style={{
          textShadow: '0 0 10px rgba(239,68,68,0.3)'
        }} data-id="element-374">
            :
          </span>

          <div className="flex flex-col items-center" data-id="element-375">
            <div className="px-5 sm:px-7 py-4 sm:py-5 rounded-xl" style={{
            background: 'linear-gradient(180deg, rgba(239,68,68,0.1) 0%, rgba(239,68,68,0.03) 100%)',
            border: '1px solid rgba(239,68,68,0.2)',
            boxShadow: '0 0 30px rgba(239,68,68,0.08), 0 0 60px rgba(239,68,68,0.03), inset 0 1px 0 rgba(239,68,68,0.1)'
          }} data-id="element-376">
              <span className="text-5xl sm:text-7xl font-black text-red-500 leading-none tracking-tighter" style={{
              textShadow: '0 0 20px rgba(239,68,68,0.5), 0 0 40px rgba(239,68,68,0.2)'
            }} data-id="element-377">
                {formatTime(timeLeft.minutes)}
              </span>
            </div>
            <span className="text-gray-500 text-[9px] sm:text-[10px] font-bold mt-2.5 tracking-[0.2em] uppercase" data-id="element-378">
              Min
            </span>
          </div>

          <span className="text-3xl sm:text-5xl font-black text-red-500/50 -mt-6" style={{
          textShadow: '0 0 10px rgba(239,68,68,0.3)'
        }} data-id="element-379">
            :
          </span>

          <div className="flex flex-col items-center" data-id="element-380">
            <div className="px-5 sm:px-7 py-4 sm:py-5 rounded-xl" style={{
            background: 'linear-gradient(180deg, rgba(239,68,68,0.1) 0%, rgba(239,68,68,0.03) 100%)',
            border: '1px solid rgba(239,68,68,0.2)',
            boxShadow: '0 0 30px rgba(239,68,68,0.08), 0 0 60px rgba(239,68,68,0.03), inset 0 1px 0 rgba(239,68,68,0.1)'
          }} data-id="element-381">
              <span className="text-5xl sm:text-7xl font-black text-red-500 leading-none tracking-tighter" style={{
              textShadow: '0 0 20px rgba(239,68,68,0.5), 0 0 40px rgba(239,68,68,0.2)'
            }} data-id="element-382">
                {formatTime(timeLeft.seconds)}
              </span>
            </div>
            <span className="text-gray-500 text-[9px] sm:text-[10px] font-bold mt-2.5 tracking-[0.2em] uppercase" data-id="element-383">
              Seg
            </span>
          </div>
        </div>

        {/* Warning message */}
        <div className="inline-flex items-center gap-2.5 px-6 py-3 rounded-lg mb-12" style={{
        background: 'rgba(239,68,68,0.06)',
        border: '1px solid rgba(239,68,68,0.15)'
      }} data-id="element-384">
          <span data-id="element-385">⚠️</span>
          <span className="text-white font-bold text-sm sm:text-base" data-id="element-386">
            Después sube{' '}
            <span className="text-red-400" style={{
            textShadow: '0 0 8px rgba(239,68,68,0.4)'
          }} data-id="element-387">
              $8.000 ARS
            </span>
            . No vuelve.
          </span>
        </div>

        {/* Progress bar */}
        <div className="w-full max-w-2xl" data-id="element-388">
          <div className="flex justify-between items-end mb-3 px-1" data-id="element-389">
            <div className="flex items-center gap-2 text-red-400 text-xs sm:text-sm font-bold" data-id="element-390">
              <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.5)]" data-id="element-391" />
              Cupos al precio de lanzamiento
            </div>
            <div className="text-white text-xs sm:text-sm font-bold" style={{
            textShadow: '0 0 10px rgba(255,255,255,0.1)'
          }} data-id="element-392">
              Quedan pocos
            </div>
          </div>

          <div className="h-3 w-full rounded-full overflow-hidden" style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.05)'
        }} data-id="element-393">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full rounded-full" style={{
            background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)',
            boxShadow: '0 0 15px rgba(239,68,68,0.4), 0 0 30px rgba(239,68,68,0.15)'
          }} data-id="element-394" />
          </div>

          <p className="text-gray-600 text-[10px] sm:text-xs mt-3 text-right tracking-wide" data-id="element-395">
            71% de los cupos ya tomados
          </p>
        </div>
      </motion.div>
    </section>;
}